import _ from 'underscore';
import { CampaignTypes, biddingStrategyTypeId } from '@bingads-webui-campaign-react/constants';
import { parseViewModelToMTModelForPMax } from './api-parser';

export const MODE = {
  CREATION: 'CREATION',
  EDITING: 'EDITING',
};

export const BudgetSuggestionTiers = {
  Advanced: 'Advanced',
  Balanced: 'Balanced',
  Starter: 'Starter',
};

export const CustomBudget = 'CustomBudget';

export const BudgetSuggestionOfflineTiers = {
  Suggested: 'Suggested',
  Current: 'Current',
};

export const RecommendedBudgetSuggestionTier = 'Suggested';

export const ApiKeysBudgetSuggestion = {
  Advanced: 'High',
  Balanced: 'Mid',
  Starter: 'Low',
};

export const BudgetTierTitles = {
  Advanced: _TL_('Accelerated'),
  Balanced: _TL_('Recommended'),
  Starter: _TL_('Basic'),
  Suggested: _TL_('Recommended'),
  Current: _TL_('Current budget'),
};

export const BudgetDetailKeys = {
  Impressions: 'Impressions',
  Clicks: 'Clicks',
  CTR: 'CTR',
  CostPerClick: 'CostPerClick',
  Conversions: 'Conversions',
  CostPerConversion: 'CostPerConversion',
};

export const BudgetDetailKeysByBidType = {
  [biddingStrategyTypeId.MaxConversions]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CostPerConversion,
  ],
  [biddingStrategyTypeId.MaxConversionValue]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CostPerConversion,
  ],
  [biddingStrategyTypeId.MaxClicks]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.CTR,
    BudgetDetailKeys.CostPerClick,
  ],
  [biddingStrategyTypeId.TargetImpressionShare]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.CTR,
    BudgetDetailKeys.CostPerClick,
  ],
  [biddingStrategyTypeId.TargetCpa]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CostPerConversion,
  ],
  [biddingStrategyTypeId.TargetRoas]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CostPerConversion,
  ],
  [biddingStrategyTypeId.EnhancedCpc]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.CTR,
    BudgetDetailKeys.CostPerClick,
  ],
  [biddingStrategyTypeId.CostPerSale]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.CTR,
    BudgetDetailKeys.CostPerClick,
  ],
  Default: [],
};


export const BudgetDetailKeysByCampaignType = {
  [CampaignTypes.PerformanceMax]: [
    BudgetDetailKeys.Clicks,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CostPerConversion,
  ],
  Default: [
    BudgetDetailKeys.Conversions,
    BudgetDetailKeys.CTR,
    BudgetDetailKeys.Impressions,
    BudgetDetailKeys.Clicks,
  ],
};

export const BudgetDetailsKeysText = {
  [BudgetDetailKeys.Impressions]: {
    title: _TL_('Monthly impr.'),
    popupId: 'pop_BA_MonthlyImpr',
  },
  [BudgetDetailKeys.Clicks]: {
    title: _TL_('Monthly clicks'),
    popupId: 'pop_BA_MonthlyClicks',
  },
  [BudgetDetailKeys.CTR]: {
    title: _TL_('Avg. CTR'),
    popupId: 'pop_BA_AvgCTR',
  },
  [BudgetDetailKeys.CostPerClick]: {
    title: _TL_('Avg. CPC'),
    popupId: 'pop_BA_AvgCostPerClick',
  },
  [BudgetDetailKeys.Conversions]: {
    title: _TL_('Monthly conv.'),
    popupId: 'pop_BA_MonthlyConv',
  },
  [BudgetDetailKeys.CostPerConversion]: {
    title: _TL_('Avg. CPA'),
    popupId: 'pop_BA_AverageCPC',
  },
};


export const getMatchingBudgetTierBasedOnBudget = (budgetSuggestionData, budgetAmount, mode) => {
  if (!budgetAmount) {
    return mode === MODE.CREATION ? BudgetSuggestionTiers.Balanced : BudgetSuggestionOfflineTiers.Suggested;
  }

  let matchingBudgetTier = mode === MODE.CREATION ? CustomBudget : BudgetSuggestionOfflineTiers.Suggested;

  if (mode === MODE.CREATION) {
    _.each(budgetSuggestionData, (budget, key) => {
      if (budget.BudgetAmountDaily === parseFloat(budgetAmount)) {
        matchingBudgetTier = key;
      }
    });
  } else {
    _.each(budgetSuggestionData, (budget, key) => {
      if (budget.BudgetAmountMonthly === parseFloat(budgetAmount)) {
        matchingBudgetTier = key;
      }
    });
  }

  return matchingBudgetTier;
};

const parserByCampaignType = {
  [CampaignTypes.PerformanceMax]: parseViewModelToMTModelForPMax,
  Default: parseViewModelToMTModelForPMax,
};


export const getParserByCampaignType = campaignType => parserByCampaignType[campaignType] || parserByCampaignType.Default;

export const formatNumber = (num) => {
  if (num >= 1e9) {
    return `${(num / 1e9).toFixed(1)}B`;
  } else if (num >= 1e6) {
    return `${(num / 1e6).toFixed(1)}M`;
  } else if (num >= 1e3) {
    return `${(num / 1e3).toFixed(1)}K`;
  } else if (num === 0) {
    return '0';
  }
  return num ? num.toString() : '';
};

export const CampaignTypeToAdvertiserChannelTypeId = {
  [CampaignTypes.Default]: 1,
  [CampaignTypes.Product]: 2,
  [CampaignTypes.Shopping]: 3,
  [CampaignTypes.DynamicSearchAds]: 4,
  [CampaignTypes.Hotel]: 5,
  [CampaignTypes.Audience]: 6,
  [CampaignTypes.Smart]: 7,
  [CampaignTypes.Hotel]: 8,
  [CampaignTypes.PerformanceMax]: 9,
};
